import React, { useEffect, useRef, useState } from 'react';
import { Button, Form, Radio } from 'antd';
import { FormInstance } from 'antd/lib/form';
import Payment from '../../../classes/payment';
import CreditCardForm from './credit-card-form';
import SepaForm from './sepa-form';
import { useTranslation } from 'react-i18next';
import SicuriProtettiServices from 'js/data/sicuri-protetti-services';

const formItemLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 8 },
};

interface IProps {
    data: Payment;
    formIsValid: (isValid: boolean, values?: any) => void;
    nextStep: () => void;
}

const PaymentForm = (props: IProps) => {
    const formRef = useRef<FormInstance>(null);
    const { t } = useTranslation();
    const [paymentTypes, setPaymentTypes] = useState<simpleStruct[]>([]);
    const [paymentTypeId, setPaymentTypeId] = useState<string>(props.data.paymentTypeId.toString());

    const onFinish = (values: any) => {
        if (document.getElementById('nation-' + values.nationId) != null)
            values.nation = document.getElementById('nation-' + values.nationId)!.getAttribute('data-nation');
        if (document.getElementById('city-' + values.cityId) != null)
            values.city = document.getElementById('city-' + values.cityId)!.getAttribute('data-city');
        if (document.getElementById('paymentType-' + values.paymentTypeId) != null)
            values.paymentType = document.getElementById('paymentType-' + values.paymentTypeId)!.getAttribute('data-paymenttype');
        if (document.getElementById('circuitId') != null)
            values.circuit = document.getElementById('circuitId')!.getAttribute('data-circuit');

        props.formIsValid(true, values);
        props.nextStep();
    };

    const onFinishFailed = () => {
        props.formIsValid(false);
    };

    const onChangePaymentType = (event) => {
        setPaymentTypeId(event.target.value);
    };

    const renderPaymentForm = (paymentType: any) => {
        switch (paymentType) {
            case '1':
                return <CreditCardForm data={props.data} formRef={formRef} />;
            case '11':
                return <SepaForm data={props.data} formRef={formRef} />;
        }
    };

    useEffect(() => {
        const getPaymentTypes = async () => {
            const paymentTypes = await SicuriProtettiServices.getPaymentTypes();
            setPaymentTypes(paymentTypes);
        };

        getPaymentTypes();
        // eslint-disable-next-line
    }, []);

    return (
        <Form id="payment-form" className={'center'} ref={formRef} onFinish={onFinish} onFinishFailed={onFinishFailed}>
            <h2 className="font-weight-600 title-content">{t('sicuri&protetti.titles.title5')}</h2>
            <br />
            <Form.Item
                {...formItemLayout}
                name={'paymentTypeId'}
                label={t('customerClass.payments.paymentType')}
                initialValue={paymentTypeId}
            >
                <Radio.Group optionType="button" buttonStyle="solid" onChange={(e) => onChangePaymentType(e)}>
                    {paymentTypes.map((paymentType) => (
                        <Radio.Button
                            key={paymentType.value}
                            value={paymentType.value}
                            id={'paymentType-' + paymentType.value}
                            data-paymenttype={paymentType.label}
                        >
                            {paymentType.label}
                        </Radio.Button>
                    ))}
                </Radio.Group>
            </Form.Item>
            {renderPaymentForm(paymentTypeId)}
            <Form.Item>
                <Button type="primary" htmlType="submit" id="payment-submit" hidden />
            </Form.Item>
        </Form>
    );
};

export default PaymentForm;
